module.exports = __webpack_public_path__ + "img/trunk.c9bd8d2a.png";